import isEmpty from './TestimonialsIsEmpty'
import Section from './TestimonialsBlock'
import Options from './TestimonialsOptions'

export default { isEmpty, Section, Options }
